<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M27 10a1 1 0 011 1v10a1 1 0 11-2 0V11a1 1 0 011-1zm-3.333 0a1 1 0 011 1v10a1 1 0 01-1 1H16v5a1 1 0 01-1.74.673l-10-11a1 1 0 010-1.346l10-11A1 1 0 0116 5v5h7.667z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'arrowsFatLineLeftFilled'
}
</script>
